import api from "../utils/api";

export const createFsrs = (data) => {
    return api.post("/fsrs/create", data);
};

export const getFsrs = (data) => {
    return api.get("/fsrs", { params: data });
};
